module.exports = __webpack_public_path__ + "img/people.5b5eeef9.png";